import React, { useEffect } from 'react'
import WinQIDesc from '../../components/Software/WinQIDesc';
import WinQIAccordions from '../../components/Software/WinQIAccordions';
const WinQI = () => {
  useEffect(() => {
    // Update the document title using the browser API
    document.title = `WinQI Software`;
  });
    return (<>
      <WinQIDesc/>
      <WinQIAccordions/>
    </>)
}

export default WinQI;